window.Office?.onReady?.()

export function isOfficeEnvironment() {
  return Boolean(window?.Office?.context?.ui)
}

export async function sendDataToOffice(data = {}) {
  await window.Office.onReady()

  window.Office.context.ui.messageParent(JSON.stringify(data), {
    targetOrigin: '*',
  })
}

export default {
  isOfficeEnvironment,
  sendDataToOffice,
}
